import React from 'react'

import CircularProgress from "@material-ui/core/CircularProgress";

const style = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const LoadingComponent = ({size = 40}) => {

  return (
    <div style={style}>
      <CircularProgress
        size={size}
      />
    </div>
  )
};
export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/assets/LoadingComponent.jsx